const DEFAULT_STEPS = ["New", "In Review", "Responded", "Closed"];
const DEFAULT_LABELS = { New: "Received", "In Review": "In Review", Responded: "Responded", Closed: "Closed" };

export const StatusTimeline = ({ status, steps = DEFAULT_STEPS, labels = DEFAULT_LABELS }) => {
  const currentIndex = steps.indexOf(status);

  return (
    <div className="flex items-center" data-testid="status-timeline">
      {steps.map((step, i) => {
        const done = i <= currentIndex;
        const isLast = i === steps.length - 1;
        return (
          <div key={step} className={`flex items-center ${isLast ? "" : "flex-1"}`}>
            <div className="flex flex-col items-center gap-1 shrink-0">
              <div
                data-testid={`status-timeline-step-${step.toLowerCase().replace(/\s/g, "-")}`}
                className={`h-6 w-6 rounded-full flex items-center justify-center text-[10px] font-bold transition-colors ${
                  done ? "bg-gold text-[#0A140F]" : "bg-ink/10 text-ink-faint"
                }`}
              >
                {i < currentIndex ? "✓" : i + 1}
              </div>
              <span className={`text-[10px] whitespace-nowrap ${done ? "text-ink font-medium" : "text-ink-faint"}`}>
                {labels[step]}
              </span>
            </div>
            {!isLast && (
              <div className={`h-0.5 flex-1 mx-1.5 mb-4 ${i < currentIndex ? "bg-gold" : "bg-ink/10"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
};
